import { type MarkSpec } from "prosemirror-model";

import { code } from "./code";
import { comment } from "./comment";
import { em } from "./em";
import { kbd } from "./kbd";
import { link } from "./link";
import { strike } from "./strike";
import { strong } from "./strong";

type MarkSpecNames = "em" | "strong" | "code" | "link" | "strike" | "comment" | "kbd";

export const marks: {
	[val in MarkSpecNames]: MarkSpec;
} = {
	link,
	em,
	strong,
	code,
	// FIXME: Underline temporarily disabled, because it's not supported by Markdown.
	strike,
	kbd,
	comment,
};
